/**
 * Global Error Handler Plugin
 */
import { safeErrorMessage, safeErrorStatusCode } from '~/types/errors'

const isDevToolsError = (error: unknown): boolean => {
  const message = safeErrorMessage(error)
  return message.includes('get-frame-manager-configuration') ||
         message.includes('frame-manager') ||
         message.includes('__NUXT_DEVTOOLS__') ||
         message.includes('devtools')
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    if (isDevToolsError(error)) return
    console.error('[Vue Error]', { message: safeErrorMessage(error), statusCode: safeErrorStatusCode(error), info, error })
    nuxtApp.runWithContext(() => {
      showError({ statusCode: safeErrorStatusCode(error), statusMessage: safeErrorMessage(error) })
    })
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (event) => {
      if (isDevToolsError(event.reason)) { event.preventDefault(); return }
      console.error('[Unhandled Promise Rejection]', { message: safeErrorMessage(event.reason), reason: event.reason })
      event.preventDefault()
    })

    window.addEventListener('error', (event) => {
      if (isDevToolsError(event.error) || isDevToolsError(event.message)) { event.preventDefault(); return }
      const errorMessage = safeErrorMessage(event.error || event.message)
      if (errorMessage === 'Script error.') { event.preventDefault(); return }
      console.error('[JavaScript Error]', { message: errorMessage, filename: event.filename })
      event.preventDefault()
    })
  }

  nuxtApp.hook('app:error', (error) => {
    console.error('[App Error]', { message: safeErrorMessage(error), statusCode: safeErrorStatusCode(error) })
  })
})
